<div class="col-lg-12 d-flex casos-esg-blq-inner-int">

    <div class="col-lg-12 col-md-12 col-sm-12 col-12 px-lg-5 px-md-0">
        <p class="text-uppercase">{{oneColAreaButtonH1_params.preTitle}}</p>
        <h1>{{oneColAreaButtonH1_params.title}}</h1>
        <p>{{oneColAreaButtonH1_params.mainText}}</p>
        <a class="btn btn-rco" routerLink="{{oneColAreaButtonH1_params.mainButtonLink}}"><p>{{oneColAreaButtonH1_params.mainButtonText}}</p></a>
    </div>

</div>
